import { getApiBasePath } from './env';

const commonFetch = async (url: string, options?: RequestInit) => {
    const API_URL = getApiBasePath();
    const res = await fetch(API_URL + url, options);
    const value = await (res.headers.get('content-type')?.includes('text')
        ? res.text()
        : res.json());

    if (!res.ok) {
        if (value && typeof value === 'object') {
            if ('title' in value && typeof value.title === 'string') {
                throw new Error(value?.title);
            } else if ('code' in value && typeof value.code === 'string') {
                throw new Error(value?.code);
            } else {
                throw new Error('Something went wrong, please try again');
            }
        }
    }

    return value;
};

const get = async (url: string, options?: RequestInit): Promise<unknown> => {
    return await commonFetch(url, {
        method: 'GET',
        ...options,
    });
};

const post = async (url: string, options?: RequestInit): Promise<unknown> => {
    return await commonFetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
        ...options,
    });
};

const put = async (url: string, options?: RequestInit): Promise<unknown> => {
    return await commonFetch(url, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
        ...options,
    });
};

const api = { get, post, put };

export default api;
